// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"4e79f48a","529":"15d676f9","545":"c92af532","570":"8c59132f","617":"648bdf6b","668":"cb02fd87","670":"ffb8acee"}[chunkId] + ".chunk.js";
};